module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIgb3BhY2l0eT0iLjEiIGZpbGw9Im5vbmUiPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik0yNCAyQzE0LjA2IDIgNiAxMC4wNiA2IDIwdjE0YzAgMy4zMSAyLjY5IDYgNiA2aDZWMjRoLTh2LTRjMC03LjczIDYuMjctMTQgMTQtMTRzMTQgNi4yNyAxNCAxNHY0aC04djE2aDh2MkgyNHY0aDEyYzMuMzEgMCA2LTIuNjkgNi02VjIwYzAtOS45NC04LjA2LTE4LTE4LTE4eiI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/icon/content-phone.svg
// module id = 33
// module chunks = 0